import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import EditorContext from '../../modules/contexts/editor';
import TextInput from './TextInput';
import { apiPaths, apiServer } from '@mirinae/shared/defines/paths';
import httpAPI from "../../modules/apis/http";

const ListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-family: Arial;
    font-size: 11px;
    border-collapse: separate;
    border-spacing: 2px 4px;
    width: 100%;
`;

const ListTable = styled.div`
    display: table;
    margin-top: 15px;
    overflow-y: auto;
`;

const BackupRow = styled.div`
    display: table-row;
`;

const Title = styled.div`
    display: table-cell;
`;

const File = styled.div`
    display: table-cell;
    padding: 0 6px;
`;

const Date = styled.div`
    display: table-cell;
    width: 150px;
`;

const CheckboxCell = styled.div`
    display: table-cell;
`;

const Checkbox = styled.input`
`;

const BackupList = ({ setSelection }) => {
    const editor = useContext(EditorContext);
    const [searchString, setSearchString] = useState('');
    const [backupList, setBackupList] = useState([]);

    useEffect(() => {
        const data = { data: { listFilter: { label: { $regex: searchString, $options: 'i' }}}};
        httpAPI(apiServer, apiPaths.listBackups, data)
            .then(data => setBackupList(data.backups))
        .catch(e => {
            editor.setShowAlert(true, `Load from database failed: ${e}`);
        });

    }, [searchString]);

    const setSelect = (backup, e) => {
        backup.selected = e.target.checked;
        setSelection(backupList.filter(b => b.selected));
    };

    return (
        <ListWrapper>
            <TextInput label="Search string" onInput={e => setSearchString(e.target.value)} />
            <ListTable>
                { backupList.map((backup, i) => (
                    <BackupRow key={i} >
                        <CheckboxCell>
                            <Checkbox type="checkbox" onChange={(e) => setSelect(backup, e)} />
                        </CheckboxCell>
                        <Title>{backup.title}</Title>
                        <File>{backup.editor && backup.editor.name.split(' ')[0] || backup.file}</File>
                        <Date>{backup.backupDate.replace('T', ' ')}</Date>
                    </BackupRow>
                ))}
            </ListTable>
        </ListWrapper>
    );
};

export default BackupList;
